import { FormattedMessage } from 'react-intl';

import type { DownloadOptions, FileFormat } from '@/features/chargingActivity/components/DownloadDropdownButton/types';

const DOWNLOAD_OPTIONS: DownloadOptions = [
    {
        id: 'header',
        translationKey: 'chargingActivity.download.note',
        isHeader: true,
    },
    {
        id: 'excel',
        format: 'XLSX',
        translationKey: 'chargingActivity.download.excel.text',
    },
    {
        id: 'csv',
        format: 'CSV',
        translationKey: 'chargingActivity.download.csv.text',
    },
] as const;

export const useDownloadOptions = (onDownload: (format: FileFormat) => Promise<void>) =>
    DOWNLOAD_OPTIONS.map(option => ({
        id: option.id,
        value: <FormattedMessage id={option.translationKey} />,
        header: option.isHeader,
        onSelect: option.isHeader ? undefined : () => onDownload(option.format),
    }));
